import React from 'react';
import { Link } from 'react-router-dom';

import logo from 'assets/images/Marketplace/header-logo.svg';
import homeLink from 'assets/images/homeLink.svg';
import homeLinkMobile from 'assets/images/homeLinkMobile.svg';

export default function HomeHeader() {
  return (
    <header className="header">
      <nav className="header-nav">
        <div className="header-logo">
          <strong className="logo">
            <Link to="/jobs-talent-aquisition">
              <img src={logo} alt="logo" />
            </Link>
          </strong>
        </div>

        <ul className="header-menu-box">
          <li>
            <Link to="/">
              <img
                src={homeLink}
                className="hidden-sm-down header-home"
                alt="logo"
              />
              <img
                src={homeLinkMobile}
                className="hidden-sm-up header-home"
                alt="logo"
              />
            </Link>
          </li>

          <li>
            <a
              href={`${process.env.REACT_APP_MARKETPLACE_URL}/login`}
              className="header-menu-opener"
            >
              <i className="icon icon-login" />
              <span>Member Login</span>
            </a>
          </li>

          <li>
            <a
              href={`${process.env.REACT_APP_MARKETPLACE_URL}/registration`}
              className="header-menu-opener"
            >
              <i className="icon icon-add-list" />
              <span>Register</span>
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}
